import { render, staticRenderFns } from "./ComponentConteudoSobreOEPeca.vue?vue&type=template&id=4619c371&scoped=true&"
import script from "./ComponentConteudoSobreOEPeca.vue?vue&type=script&lang=js&"
export * from "./ComponentConteudoSobreOEPeca.vue?vue&type=script&lang=js&"
import style0 from "./ComponentConteudoSobreOEPeca.vue?vue&type=style&index=0&id=4619c371&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4619c371",
  null
  
)

export default component.exports